import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Stack from "@mui/material/Stack";
import { SponsorsSection } from "./index";

export const SponsorCards = () => {
   return (
      <>
         <div className="web-sponsor-view" style={{ marginBottom: "2.5vh" }}>
            <div
               className="container sponsor-card"
               style={{ fontFamily: "Roboto Condensed, sans-serif !important" }}
            >
               <h1
                  style={{
                     textAlign: "center",
                     fontWeight: "900",
                     color: "white",
                     paddingTop: "5vh",
                  }}
               >
                  THANK YOU TO OUR SPONSORS
               </h1>
               <div>

                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div
                           style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                           }}
                        >
                           <a
                              href="https://brownrudnick.com/"
                              style={{
                                 textAlign: "center",
                                 display: "flex",
                                 justifyContent: "center",
                                 alignItems: "center",
                                 gap: "5%",
                                 padding: "1%",

                              }}
                           >
                              <h3 style={{ color: "black" }}>Diamond Sponsor</h3>
                              <img alt='sponsor'
                                 style={{ maxWidth: "25%", objectFit: 'scale-down' }}
                                 src="./assets/media/brown_rudnick.webp"
                              />
                           </a>
                        </div>
                        <div className="row" style={{ height: "50%" }}>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "15%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Diamond Sponsor</div>
                      
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "grid",
                                 gridTemplateColumns: "repeat(3, 1fr)",
                                 gridTemplateRows: "repeat(2, 1fr)",
                                 flex: 1,
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/Dave-Sorin_3265-Crop-Print.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    David Sorin,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/david-sorin-6674898/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed , sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/Jared-Sorin_3195-Crop-Print.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Jared Sorin,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/jaredsorin/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/Matt-Uretsky_3348-Crop-Print.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Matthew Uretsky,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/matthew-uretsky-b767883b/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>

                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       marginTop: "2vh",
                                    }}
                                    src="./assets/media/Joseph-Ferino_3468-Crop-Print.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Joseph Ferino,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/joseph-ferino-1980218/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       marginTop: "2vh",
                                    }}
                                    src="./assets/media/Cohen_Michael NEW.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Michael Cohen,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/mcohenesq/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       marginTop: "2vh",
                                    }}
                                    src="./assets/media/Carter, Alvin.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Alvin B. Carter III,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Associate</i>{" "}
                                    <a href="https://www.linkedin.com/in/alvincarter3/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              <div>
                                 Brown Rudnick is an international law firm with offices in
                                 key financial centers across the United States and Europe,
                                 and lawyers serving clients around the globe. We are
                                 recognized for our market-leading practices covering
                                 several targeted industries, including technology, life
                                 sciences, corporate finance, strategic capital, distressed
                                 debt, intellectual property, real estate, M&A, bankruptcy
                                 and corporate restructuring, litigation and arbitration,
                                 white-collar defense, investigations and compliance, civil
                                 fraud, special situations, and cross-border deals and
                                 disputes.
                              </div>
                              <br />
                              {/* <a
                      href="https://www.brownrudnick.com"
                      target="_blank"
                      style={{ paddingRight: "75px" }}
                    >
                      www.brownrudnick.com
                    </a> */}
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "2rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div
                           style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              padding: "1%",
                           }}
                        >
                           <h3>Diamond Sponsor</h3>
                           <a href="https://palladiumcapital.com/">
                              <img alt='sponsor'
                                 style={{ maxWidth: "200%" }}
                                 src="./assets/media/Palladium Capital.png"
                              />
                           </a>
                        </div>

                        <div className="row" style={{ height: "50%" }}>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <span style={{ fontSize: "1.25rem" }}>
                        Diamond Sponsor
                      </span>

                      <a href="https://palladiumcapital.com/">
                        <img alt='sponsor'
                          style={{ maxWidth: "200%" }}
                          src="./assets/media/Palladium Capital.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <Stack sx={{ flex: 1 }}>
                              <div
                                 style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(3, 1fr)",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                 }}
                              >
                                 <div
                                    style={{
                                       textAlign: "center",
                                       fontFamily: "Roboto Condensed, sans-serif !important",
                                    }}
                                 >
                                    <img alt='sponsor'
                                       style={{
                                          borderRadius: "100%",
                                          width: "55%",
                                          height: "85%",
                                          boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       }}
                                       src="./assets/media/joel padowitz.png"
                                    />
                                    <div style={{ fontSize: "1.1rem" }}>
                                       Joel Padowitz,{" "}
                                       <i style={{ fontSize: ".85rem" }}>CEO</i>{" "}
                                       <a href="https://www.linkedin.com/in/joel-padowitz-mba-cfa-95b58b11/">
                                          <LinkedInIcon />
                                       </a>
                                    </div>
                                 </div>
                                 <div
                                    style={{
                                       textAlign: "center",
                                       fontFamily:
                                          "Roboto Condensed , sans-serif !important",
                                    }}
                                 >
                                    <img alt='sponsor'
                                       style={{
                                          borderRadius: "100%",
                                          width: "55%",
                                          height: "85%",
                                          boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       }}
                                       src="./assets/media/Alfonso Alejo.png"
                                    />
                                    <div style={{ fontSize: "1.1rem" }}>
                                       Alfonso Alejo,{" "}
                                       <i style={{ fontSize: ".85rem" }}>Chairman</i>{" "}
                                       <a href="https://www.linkedin.com/in/alfonso-alejo-27415b3/">
                                          <LinkedInIcon />
                                       </a>
                                    </div>
                                 </div>
                                 <div
                                    style={{
                                       textAlign: "center",
                                       fontFamily: "Roboto Condensed, sans-serif !important",
                                    }}
                                 >
                                    <img alt='sponsor'
                                       style={{
                                          borderRadius: "100%",
                                          width: "55%",
                                          height: "85%",
                                          boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       }}
                                       src="./assets/media/Marc Wiersum.png"
                                    />
                                    <div style={{ fontSize: "1.1rem" }}>
                                       Marc Wiersum,{" "}
                                       <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                       <a href="https://www.linkedin.com/in/marcwiersum/">
                                          <LinkedInIcon />
                                       </a>
                                    </div>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, 1fr)",
                                    gridColumnGap: "0px",
                                    justifyContent: "center",
                                    flexWrap: "wrap",
                                    alignItems: "center",
                                    width: "fit-content",
                                    margin: "auto",
                                    marginTop: "2.5vh",
                                 }}
                              >
                                 <div
                                    style={{
                                       textAlign: "center",
                                       fontFamily: "Roboto Condensed, sans-serif !important",
                                    }}
                                 >
                                    <img alt='sponsor'
                                       style={{
                                          borderRadius: "100%",
                                          width: "60%",
                                          height: "85%",
                                          boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       }}
                                       src="./assets/media/Byron Haney.png"
                                    />
                                    <div style={{ fontSize: "1.1rem" }}>
                                       Byron Haney,{" "}
                                       <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                       <a href="https://www.linkedin.com/in/byron-haney/">
                                          <LinkedInIcon />
                                       </a>
                                    </div>
                                 </div>
                                 <div
                                    style={{
                                       textAlign: "center",
                                       fontFamily: "Roboto Condensed, sans-serif !important",
                                    }}
                                 >
                                    <img alt='sponsor'
                                       style={{
                                          borderRadius: "100%",
                                          width: "60%",
                                          height: "85%",
                                          boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       }}
                                       src="./assets/media/Elaine Pang.png"
                                    />
                                    <div style={{ fontSize: "1.1rem" }}>
                                       Elaine Pang,{" "}
                                       <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                       <a href="https://www.linkedin.com/in/elaine-pang-365729/">
                                          <LinkedInIcon />
                                       </a>
                                    </div>
                                 </div>
                              </div>
                           </Stack>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Palladium Capital Group is a leading microcap investment
                              bank specializing in PIPEs, private equity, venture capital,
                              reverse mergers, commercial real estate, and the secondary
                              placement of private equity and investment fund interests.
                              Since its founding in 2004, the firm has facilitated
                              hundreds of transactions totaling billions of dollars, and
                              today is represented by more than twenty bankers and brokers
                              throughout the United States.
                           </div>
                        </div>
                     </div>
                  </section>
                  {/* <section
              className="container sponsor-card"
              style={{
                padding: "3rem",
                backgroundColor: "white",
                borderRadius: "10px",
                marginTop: "5vh",
              }}
            >
              <div style={{ height: "fit-content" }}>
                <div className="row" style={{ height: "50%" }}>
                  <div className="col-md-3" style={{ paddingTop: "2vh" , position:'relative'}}>
                    <div
                      style={{
                        position: "absolute",
                        bottom: "%",
                        left: "15%",
                        fontFamily: "Roboto Condensed, sans-serif !important",
                      }}
                    >
                      <span style={{ fontSize: "1.25rem" }}>
                        Diamond Sponsor
                      </span>

                      <a href="https://www.burnslev.com/">
                        <img alt='sponsor'
                          style={{maxWidth:"120%", marginLeft:"-3rem", padding:"2rem"}}
                          src="./assets/events/vsvc21/sponsors/Burns-Levinson-LLP.png"
                        />
                      </a>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flex: ".65",
                      justifyContent: "center",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontFamily: "Roboto Condensed, sans-serif !important",
                      }}
                    >
                      <img alt='sponsor'
                        style={{
                          borderRadius: "100%",
                          width: "85%",
                          height: "75%",
                        }}
                        src="./assets/events/vsvc21/sponsors/joseph-volman-e1638277236911.jpeg"
                      />
                      <div style={{ fontSize: "1.1rem", marginTop: ".5rem" }}>
                        Joe Volman,{" "}
                        <i style={{ fontSize: ".85rem" }}>Co-Chair</i>{" "}
                        <a href="https://www.linkedin.com/in/josefvolman/">
                         <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="row"
                  style={{ height: "50%", justifyContent: "center" }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: "80%",
                      marginTop: "2vh",
                      fontSize: "1.15rem",
                      fontFamily: "Roboto Condensed, sans-serif",
                    }}
                  >
                    At Burns & Levinson, we practice law differently. While our
                    attorneys agree that results drive our business, building
                    relationships with our clients and providing value added
                    service is the key to our success. We work hard to provide
                    the legal experience and industry knowledge you need, as
                    well as the personal attention you deserve - adding value to
                    your life and the life of your business. Your personal and
                    business success is our top priority. So whatever your legal
                    need, consider it done.
                  </div>
                </div>
              </div>
            </section>
            <section
              className="container sponsor-card"
              style={{
                padding: "1rem",
                backgroundColor: "white",
                borderRadius: "10px",
                marginTop: "5vh",
              }}
            >
              <div style={{ height: "fit-content" }}>
                <div className="row" style={{ height: "50%" }}>
                  <div className="col-md-3" style={{ paddingTop: "2vh" , position:'relative'}}>
                    <div style={{position:"absolute", bottom:"5%", left:"15%", fontFamily: "Roboto Condensed , sans-serif !important"}}>
                      <span style={{fontSize:"1.25rem"}}>Platinum Sponsor</span>

                      <a href="https://www.oracle.com/startup/">
                        <img alt='sponsor'
                          style={{maxWidth:"120%", marginLeft:"0rem"}}
                          src="./assets/events/vsvc21/sponsors/Oracle_forStartups.png"
                        />
                      </a>
                    </div>
                  </div>
                  <div style={{display:"flex", flex:"1", justifyContent:"center", flexWrap:"wrap"}}>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"65%", height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/ezgif.com-gif-maker.webp"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Kenan Kitchen,{" "}
                        <i style={{fontSize:".85rem"}}>VC Manager</i> {" "}
                        <a href="https://www.linkedin.com/in/kenankitchen/">
                          <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed , sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"65%", height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/perry-light-e1638273461568.jpg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Perry Light, <i style={{fontSize:".85rem"}}>Market Lead</i>{" "}
                        {" "}
                        <a href="https://www.linkedin.com/in/perrylight/">
                         <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"65%", height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/carter-geisbush-e1638273609987.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Carter Geisbush,{" "}
                        <i style={{fontSize:".85rem"}}>Team Lead</i> {" "}
                        <a href="https://www.linkedin.com/in/cartergeisbush/">
                        <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius: "100%", width: "62%", height: "82.5%"}}
                        src="./assets/events/vsvc21/sponsors/franco-lebolo-e1638273693984.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Franco Lebolo,{" "}
                        <i style={{fontSize:".85rem"}}>Business Manager</i>{" "}
                        <a href="https://www.linkedin.com/in/francolebolo/">
                        <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"50%", height:"83.5%"}}
                        src="./assets/events/vsvc21/sponsors/claudia-fajkarz-e1638273809544.jpeg"
                      />
                      <div style={{fontSize:"1.1rem", marginLeft:"1rem"}}>
                        {" "}
                        Claudia Fajkarz,{" "}
                        <i style={{fontSize:".85rem"}}>
                          Business Development
                        </i>{" "}
                        {" "}
                        <a href="https://www.linkedin.com/in/claudiafaj/">
                        <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="row"
                  style={{ height: "50%", justifyContent: "center" }}
                >
                  <div style={{textAlign:"center", width:"80%", marginTop:"5vh", fontSize:"1.15rem", fontFamily: "Roboto Condensed, sans-serif"}}>
                    Oracle Corporation (NYSE: ORCL) is a computer technology
                    company headquartered in Austin, Texas. Oracle offers
                    integrated suites of applications plus secure, autonomous
                    infrastructure in the Oracle Cloud. With 2020 revenue over
                    39 billion, Oracle was ranked 80 in the Forbes 500 list of
                    largest US companies.
                  </div>
                </div>
              </div>
            </section> */}
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "2rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <h3>Platinum Sponsor</h3>
                              <a href="https://www.mwe.com/">
                                 <img alt='sponsor'
                                    style={{ maxWidth: "200%" }}
                                    src="./assets/media/McDermott-Will-Emery-LLP_2021.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <span style={{ fontSize: "1.25rem" }}>
                        Platinum Sponsor
                      </span>

                      <a href="https://www.mwe.com/">
                        <img alt='sponsor'
                          style={{ maxWidth: "200%" }}
                          src="./assets/events/vsvc21/sponsors/McDermott-Will-Emery-LLP_2021.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 width: "90%",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/angus-mcquilken-e1638275277458.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Angus McQuilken,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Executive</i>{" "}
                                    <a href="https://www.linkedin.com/in/angus-mcquilken-a682326/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed , sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/byron-kalogerou-e1638275355958.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Byron Kalogerou,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Chairman</i>{" "}
                                    <a href="https://www.linkedin.com/in/byron-kalogerou-5893582/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "82.5%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/brian-gordon-e1638275459582.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Brian Gordon,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/brian-gordon-475a652/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "82.5%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       marginTop: "2vh",
                                    }}
                                    src="./assets/media/mark-mihanovic-e1638275550487.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Mark Mihanovic,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/mark-mihanovic-5927b66/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "82.5%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                       marginTop: "2vh",
                                    }}
                                    src="./assets/media/amora-sharma-e1638275631418.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Aroma Sharma,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Partner</i>{" "}
                                    <a href="https://www.linkedin.com/in/aromasharma/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              McDermott's Life Sciences Team will get you closer to your
                              goals. Composed of top lawyers with demonstrated strength
                              across intellectual property, regulatory, transactional and
                              litigation law, we're a purpose-built team of thought
                              leaders united by a passion for our work. Our team can meet
                              the legal needs of life sciences companies at every stage of
                              development. For decades, we have embraced the value of
                              focused knowledge, harnessing both the particular skills of
                              individuals and the collective experience of our team. This
                              makes us uniquely qualified to help you move business
                              initiatives across the finish line when it matters and
                              anticipate what's next.
                           </div>
                        </div>
                     </div>
                  </section>
                  {/* <section
              className="container sponsor-card"
              style={{
                padding: "1rem",
                backgroundColor: "white",
                borderRadius: "10px",
                marginTop: "5vh",
              }}
            >
              <div style={{ height: "fit-content" }}>
                <div className="row" style={{ height: "50%" }}>
                  <div className="col-md-3" style={{ paddingTop: "2vh" , position:'relative'}}>
                    <div style={{position:"absolute", bottom:"5%", left:"15%", fontFamily: "Roboto Condensed , sans-serif !important"}}>
                      <span style={{fontSize:"1.25rem"}}>Coaching Sponsor</span>

                      <a href="https://www.troutman.com/">
                        <img alt='sponsor'
                          style={{maxWidth:"100%", marginLeft:"-2rem"}}
                          src="./assets/events/vsvc21/sponsors/Troutman-Pepper-LLP.jpeg"
                        />
                      </a>
                    </div>
                  </div>
                  <div style={{display:"flex", flex:"1",justifyContent:"space-around", flexWrap:"wrap",alignItems:"center"}}>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"65%", height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/gregory-len-e1638279233893.jpg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Gregory Len, <i style={{fontSize:".85rem"}}>Partner</i>{" "}
                        {" "}
                        <a href="https://www.linkedin.com/in/gregory-len-03312322/">
                           <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed , sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"65%", height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/steven-london-e1638279440606.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Steven London, <i style={{fontSize:".85rem"}}>Partner</i>{" "}
                        {" "}
                        <a href="https://www.linkedin.com/in/steven-r-london-b411114/">
                           <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"65%", height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/nicholas-stawasz-e1638279506464.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Nicholas Stawasz,{" "}
                        <i style={{fontSize:".85rem"}}>Partner</i> {" "}
                        <a href="https://linkedin.com/in/nicholasstawasz/">
                           <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"53%", height:"62%"}}
                        src="./assets/events/vsvc21/sponsors/brian-dolan-e1638295519871.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Brian Dolan,{" "}
                        <i style={{fontSize:".85rem"}}>
                          Business Development Manager
                        </i>{" "}
                        {" "}
                        <a href="https://www.linkedin.com/in/brianedolan/">
                           <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="row"
                  style={{ height: "50%", justifyContent: "center" }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: "80%",
                      marginTop: "2vh",
                      fontSize: "1.15rem",
                      fontFamily: "Roboto Condensed, sans-serif",
                    }}
                  >
                    Putting clients first — and empowering our attorneys and
                    staff to innovate toward that end — has led to exciting
                    advances, like our proprietary e-discovery service, bespoke
                    technology solutions, and market-leading client feedback
                    program. We’re proud to be among BTI’s 2021 Client Service
                    A-Team, and to earn Law Firm Innovator honors from The Legal
                    Intelligencer for a custom, AI-powered solution for more
                    efficient and equitable project staffing.
                  </div>
                </div>
              </div>
            </section>
            <section
              className="container sponsor-card"
              style={{
                padding: "1rem",
                backgroundColor: "white",
                borderRadius: "10px",
                marginTop: "5vh",
              }}
            >
              <div style={{ height: "fit-content" }}>
                <div className="row" style={{ height: "50%" }}>
                  <div className="col-md-3" style={{ paddingTop: "2vh" , position:'relative'}}>
                    <div style={{position:"absolute", bottom:"5%", left:"15%", fontFamily: "Roboto Condensed , sans-serif !important"}}>
                      <div style={{fontSize:"1.25rem"}}>
                      Europe Partner
                      </div>

                      <a href="https://www.invest-in-bavaria.com/en/">
                        <img alt='sponsor'
                          style={{maxWidth:"90%"}}
                          src="./assets/events/vsvc21/sponsors/Invest-in-Bavaria_2019.png"
                        />
                      </a>
                    </div>
                  </div>
                  <div style={{display:"flex",flex:".7",justifyContent:"center", flexWrap:"wrap",alignItems:"center"}}>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%",width:"65%",height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/jan-sutherland-e1638291767699.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Jan Sutherland,{" "}
                        <i style={{fontSize:".85rem"}}>Executive Director</i>{" "}
                        {" "}
                        <a href="https://www.linkedin.com/in/jan-danisman-sutherland-5b632518/">
                           <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="row"
                  style={{ height: "50%", justifyContent: "center" }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: "80%",
                      marginTop: "2vh",
                      fontSize: "1.15rem",
                      fontFamily: "Roboto Condensed, sans-serif",
                    }}
                  >
                    Invest in Bavaria has been in existence since 1999 and
                    offers companies a wealth of services for all stages of
                    setting up a business in the state, from the planning phase,
                    throughout the search for and selection of a location, to
                    implementation.Even once companies are successfully settled,
                    Invest in Bavaria continues to support them, such as during
                    a planned expansion.
                  </div>
                </div>
              </div>
            </section> */}
                  {/* <section
              className="container sponsor-card"
              style={{
                padding: "1rem",
                backgroundColor: "white",
                borderRadius: "10px",
                marginTop: "5vh",
              }}
            >
              <div style={{ height: "fit-content" }}>
                <div className="row" style={{ height: "50%" }}>
                  <div className="col-md-3" style={{ paddingTop: "2vh" , position:'relative'}}>
                    <div style={{position:"absolute", bottom:"5%", left:"15%", fontFamily: "Roboto Condensed , sans-serif !important"}}>
                      <div style={{fontSize:"1.25rem"}}>Gold Sponsor</div>

                      <a href="https://www.zendesk.com/startups/">
                        <img alt='sponsor'
                          style={{maxWidth:"50%"}}
                          src="./assets/events/vsvc21/sponsors/Zendesk-startups-logo-kale-transparent-2.png"
                        />
                      </a>
                    </div>
                  </div>
                  <div style={{display:"flex", flex:"1",justifyContent:"space-around", flexWrap:"wrap",alignItems:"center"}}>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed, sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%", width:"55%", height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/adam-odonell-e1638289540122.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Adam O'Donnell,{" "}
                        <i style={{fontSize:".85rem"}}>
                          VC & Startup Partnerships
                        </i>{" "}
                        
                        <a href="https://www.linkedin.com/in/adamfodonnell/">
                           <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                    <div style={{textAlign:"center", fontFamily: "Roboto Condensed , sans-serif !important"}}>
                      <img alt='sponsor'
                        style={{borderRadius:"100%",width:"65%",height:"85%"}}
                        src="./assets/events/vsvc21/sponsors/tommy-klouwers-e1638289550974.jpeg"
                      />
                      <div style={{fontSize:"1.1rem"}}>
                        Tommy Klouwers,{" "}
                        <i style={{fontSize:".85rem"}}>Growth Manager</i> {" "}
                        <a href="https://www.linkedin.com/in/tommyklouwers/">
                           <LinkedInIcon />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="row"
                  style={{ height: "50%", justifyContent: "center" }}
                >
                  <div
                    style={{
                      textAlign: "center",
                      width: "80%",
                      marginTop: "2vh",
                      fontSize: "1.15rem",
                      fontFamily: "Roboto Condensed, sans-serif",
                    }}
                  >
                    Zendesk is a service-first CRM company that builds software
                    designed to improve customer relationships.As employees, we
                    encourage each other to grow and innovate.As a company, we
                    roll up our sleeves to plant roots in the communities we
                    call home.Our software is powerful and flexible, and scales
                    to meet the needs of any business.Even yours.
                  </div>
                </div>
              </div>
            </section> */}
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <h3>Gold Sponsor</h3>
                              <a href="https://www.agencyip.com/">
                                 <img alt='sponsor'
                                    style={{ maxWidth: "135%" }}
                                    src="./assets/media/logo.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                     
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/joshua 1.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Joshua Pichinson,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Managing Director</i>{" "}
                                    <a href="https://www.linkedin.com/in/jpichinson/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              agencyIP assists our clients to identify hidden value and
                              work on developing addition ways to monetize your patent,
                              trademark, and copyright assets. Being industry experts, we
                              enable our clients to fully monetize and enjoy long-term
                              success through agencyIP relationships and strategies.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "3rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a href="https://boardsi.com/"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Gold Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{
                                       maxWidth: "225%",

                                       padding: "2rem",
                                    }}
                                    src="./assets/media/boardsi.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "%",
                        left: "15%",
                        fontFamily: "Roboto Condensed, sans-serif !important",
                      }}
                    >
                      <span style={{ fontSize: "1.25rem" }}>
                        Venture Sponsor
                      </span>

                      <a href="https://www.allstate.com/strategic-ventures/main.htm">
                        <img alt='sponsor'
                          style={{
                            width: "250px",
                            marginLeft: "-3rem",
                            padding: "2rem",
                          }}
                          src="./assets/media/Allstate-Strategic-Ventures.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "grid",
                                 gridTemplateColumns: "repeat(2, 1fr)",
                                 flex: "1",
                                 margin: "auto",
                                 justifyContent: "space-around",

                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "37.5%",
                                       height: "75%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/MartinRowinski030122.png"
                                 />
                                 <div style={{ fontSize: "1.1rem", marginTop: ".5rem" }}>
                                    Martin Rowinski,{" "}
                                    <i style={{ fontSize: ".85rem" }}>CEO</i>{" "}
                                    <a href="https://www.linkedin.com/in/martinrowinski/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "37.5%",
                                       height: "75%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/daniel-henry.jpeg"
                                 />
                                 <div style={{ fontSize: "1.1rem", marginTop: ".5rem" }}>
                                    Daniel Henry,{" "}
                                    <i style={{ fontSize: ".85rem" }}>COO</i>{" "}
                                    <a href="https://www.linkedin.com/in/daniel-henry-21983340/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Boardsi is a modern recruiting company providing executives with advisory positions and companies with top talent. Through our advanced technology, human connection and private network we help revolutionize businesses and grow careers.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <h3>Gold Sponsor</h3>
                              <a href="https://www.cartika.com/">
                                 <img alt='sponsor'
                                    style={{ maxWidth: "135%" }}
                                    src="./assets/media/Cartika-250x134.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                      <a href="https://www.cartika.com/">
                        <img alt='sponsor'
                          style={{ maxWidth: "135%" }}
                          src="./assets/events/vsvc21/sponsors/Cartika-250x134.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/andrew-rouchotas-e1638289749607.jpeg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Andrew Rouchotas,{" "}
                                    <i style={{ fontSize: ".85rem" }}>CEO</i>{" "}
                                    <a href="https://www.linkedin.com/in/andrewrouchotascartikaceo/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              We specialize in pro-actively managed public cloud and
                              personalized IaaS infrastructure, including meeting and
                              exceeding compliance standards.Whether you are hosting
                              internal applications, file storage and/or web based
                              applications like Content Management or eCommerce, no matter
                              how complex your infrastructure architecture, Cartika can
                              accommodate your requirements.If you are storing any
                              personal data and require data compliance, you absolutely
                              need to speak with Cartika about our proactive and data
                              compliant Managed Services.
                           </div>
                        </div>
                     </div>
                  </section>

                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a
                                 href="https://www.linkedin.com/in/mfalato/"
                                 style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3>Gold Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "25%", padding: "1rem" }}
                                    src="./assets/media/fullthrottlefalatoleads.jpeg"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                      <a href="https://www.linkedin.com/in/mfalato/">
                        <img alt='sponsor'
                          style={{ maxWidth: "125%", padding: "1rem" }}
                          src="./assets/events/vsvc21/sponsors/fullthrottlefalatoleads.jpeg"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/michael-falato.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Michael Falato,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Founder</i>{" "}
                                    <a href="https://www.linkedin.com/in/mfalato/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Full Throttle Falato Leads provides on-demand sales lead
                              generation for business to business clients for less than a
                              full-time sales person’s salary. We have access to over 950
                              million contacts and can develop persona-based drip
                              marketing campaigns using Emails & LinkedIn automation. We
                              will provide a shorter revenue cycle, tighten the messaging,
                              as well as provide metrics, insights, and consultation.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a
                                 href="https://innovationcenter.tech/"
                                 style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3>Gold Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "30%", padding: "1rem" }}
                                    src="./assets/media/IC-logo-2.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                      
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/Iva-Abadjieva.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Ivelina Abadjieva,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Founder</i>{" "}
                                    <a href="https://www.linkedin.com/in/iva-abadjieva-b778b36/?originalSubdomain=bg">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Innovation Center creates business opportunities for
                              investors and startups from the US showcasing how they can
                              take advantage of available talents, low cost of business,
                              infrastructure, the entrepreneurial spirit, and the support
                              of local governments and authorities in EMEA.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a
                                 href="https://www.jetro.go.jp/en/"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Gold Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "125%", padding: "1rem" }}
                                    src="./assets/media/jetro_logo.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                      
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "45%",
                                       height: "65%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/gerald_cook.jpeg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Gerald Cook,{" "}
                                    <i style={{ fontSize: ".85rem" }}>
                                       Business Development Representative
                                    </i>{" "}
                                    <a href="https://www.linkedin.com/in/geraldcook/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              JETRO, or the Japan External Trade Organization, is a
                              government-related organization that works to promote mutual
                              trade and investment between Japan and the rest of the
                              world. Originally established in 1958 to promote Japanese
                              exports abroad, JETRO's core focus in the 21st century has
                              shifted toward promoting foreign direct investment into
                              Japan and helping small to medium size Japanese firms
                              maximize their global export potential.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a
                                 href="https://mongotel.com/"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Gold Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "125%", padding: "1rem" }}
                                    src="./assets/media/mongotel-e1638444035285.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                      <a href="https://mongotel.com/">
                        <img alt='sponsor'
                          style={{ maxWidth: "125%", padding: "1rem" }}
                          src="./assets/events/vsvc21/sponsors/mongotel-e1638444035285.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/david-levine-e1638290639365.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    David Levine,{" "}
                                    <i style={{ fontSize: ".85rem" }}>VP of Sales</i>{" "}
                                    <a href="https://www.linkedin.com/in/davidlevinemongotel/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              MongoTEL works reliably and includes inherent security.You
                              can grow the system easily and upgrade seamlessly to new
                              features. No matter how small or large, you'll have the
                              right bandwidth and accessibility for crystal clear
                              conversations, no matter where you make the call.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a
                                 href="https://salesqualia.com/"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Gold Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "135%" }}
                                    src="./assets/media/Group 109 (1).png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                      <a href="https://salesqualia.com/">
                        <img alt='sponsor'
                          style={{ maxWidth: "135%" }}
                          src="./assets/media/Group 109 (1).png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/Scott Sambucci headshot 1.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Scott Sambucci,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Founder & CEO</i>{" "}
                                    <a href="https://www.linkedin.com/in/scottsambucci/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "50%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/eura-edmond 1.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Eura Edmond,{" "}
                                    <i style={{ fontSize: ".85rem" }}>
                                       Customer Success Director
                                    </i>{" "}
                                    <a href="https://www.linkedin.com/in/euraedmond/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/amy-cox 1.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Amy Cox,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Head of Operations</i>{" "}
                                    <a href="https://www.linkedin.com/in/coxamy/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/ruby-vasquez 1.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Ruby Vasquez,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Event Coordinator</i>{" "}
                                    <a href="https://www.linkedin.com/in/annarubyvasquez/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Founded in 2011, SalesQualia is dedicated to helping early
                              stage B2B start­ups ramp up and scale up their revenue and
                              sales process so that they can make the impact they want in
                              their markets. Our company’s mission is to help 100
                              enterprise startups reach $10mm ARR in the next 10 years.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a
                                 href="https://www.shrwood.com/Home"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Gold Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "135%" }}
                                    src="./assets/media/Sherwood Black 1.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <div style={{ fontSize: "1.25rem" }}>Gold Sponsor</div>

                      <a href="https://www.shrwood.com/Home">
                        <img alt='sponsor'
                          style={{ maxWidth: "135%" }}
                          src="./assets/media/Sherwood Black 1.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: ".7",
                                 margin: "auto",
                                 justifyContent: "center",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "55%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/martin 1.png"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Martin Pichinson,{" "}
                                    <i style={{ fontSize: ".85rem" }}>CEO</i>{" "}
                                    <a href=" https://www.linkedin.com/in/pichinson/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Since 1992, Sherwood Partners, Inc. (Sherwood Partners) has
                              become one of the premier business advisory and consulting
                              firms. Our team of seasoned business professionals provides
                              founders, shareholders, senior executives, boards and
                              financial institutions more than a report. We deliver
                              ‘experience’. At Sherwood Partners, we go beyond traditional
                              consulting and advisory services to help make decisions and
                              implement plans that achieve exceptional results. ‘The
                              Industry Knows Sherwood and Sherwood Knows the Industry’.
                              GET SHERWOOD!
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "3rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a href="https://www.allstate.com/strategic-ventures/main.htm"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Venture Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{
                                       width: "250px",
                                       marginLeft: "-3rem",
                                       padding: "2rem",
                                    }}
                                    src="./assets/media/Allstate-Strategic-Ventures.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "%",
                        left: "15%",
                        fontFamily: "Roboto Condensed, sans-serif !important",
                      }}
                    >
                      <span style={{ fontSize: "1.25rem" }}>
                        Venture Sponsor
                      </span>

                      <a href="https://www.allstate.com/strategic-ventures/main.htm">
                        <img alt='sponsor'
                          style={{
                            width: "250px",
                            marginLeft: "-3rem",
                            padding: "2rem",
                          }}
                          src="./assets/media/Allstate-Strategic-Ventures.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: "1",
                                 margin: "auto",
                                 justifyContent: "space-around",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "75%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/Tarik-Galijasevic.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem", marginTop: ".5rem" }}>
                                    Tarik Galijasevic,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Co-Chair</i>{" "}
                                    <a href="https://www.linkedin.com/in/tarik-galijasevic-1563201/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "75%",
                                       height: "75%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/Reese-Schroeder.jpeg"
                                 />
                                 <div style={{ fontSize: "1.1rem", marginTop: ".5rem" }}>
                                    Reese Schroeder,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Co-Chair</i>{" "}
                                    <a href="https://www.linkedin.com/in/reese-schroeder-167652/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Founded in 2015, Allstate Strategic Ventures (ASV) is the
                              corporate venture capital arm of Allstate Insurance Company,
                              a leader in the property and casualty insurance market in
                              the United States. We invest in entrepreneurs whose
                              disruptive technologies — ranging from insurtech to new
                              mobility models to deep and frontier tech — will help shape
                              the future of the insurance industry and adjacent sectors.
                              ASV has a long history of strategic investing and has built
                              a world-class portfolio of companies.
                           </div>
                        </div>
                     </div>
                  </section>
                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a href="https://www.energyfoundry.com/"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Venture Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "80%", paddingTop: "2rem", paddingBottom: '2.5vh' }}
                                    src="./assets/media/bcda75fe6b78252432383bf72adc0c1b-1-250x88.png"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-3"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <span style={{ fontSize: "1.25rem" }}>
                        Venture Sponsor
                      </span>

                      <a href="https://www.energyfoundry.com/">
                        <img alt='sponsor'
                          style={{ maxWidth: "80%", paddingTop: "2rem" }}
                          src="./assets/events/vsvc21/sponsors/bcda75fe6b78252432383bf72adc0c1b-1-250x88.png"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: "1",
                                 margin: 'auto',
                                 justifyContent: "space-around",
                                 flexWrap: "wrap",
                                 alignItems: "center",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed , sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "48.5%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/jason-blumberg-e1638285854576.jpg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Jason Blumberg,{" "}
                                    <i style={{ fontSize: ".85rem" }}>
                                       Co-Founder & Managing Manager
                                    </i>{" "}
                                    <a href="https://www.linkedin.com/in/jasonblumberg/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "62%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/sara-chamberlain-e1638285967913.jpeg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Sara Chamberlain,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Managing Director</i>{" "}
                                    <a href="https://www.linkedin.com/in/sarahochmanchamberlain/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Energy Foundry invests venture capital in today’s most
                              promising energy & cleantech innovators, and we work with
                              the world’s leading companies to build and scale new
                              ventures.Our approach merges venture capital with the perks
                              of partnership, and includes an arsenal of essential tools
                              and relationships to help bring great ideas to market.
                           </div>
                        </div>
                     </div>
                  </section>

                  <section
                     className="container sponsor-card"
                     style={{
                        padding: "1rem",
                        backgroundColor: "white",
                        borderRadius: "10px",
                        marginTop: "5vh",
                     }}
                  >
                     <div style={{ height: "fit-content" }}>
                        <div className="row" style={{ height: "50%" }}>
                           <div
                              style={{
                                 display: "flex",
                                 alignItems: "center",
                                 justifyContent: "center",
                                 gap: "5%",
                              }}
                           >
                              <a href="https://masaimpact.com/"
                                 style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5%",
                                    color: "black",
                                 }}
                              >
                                 <h3 style={{ whiteSpace: "nowrap" }}>Venture Sponsor</h3>
                                 <img alt='sponsor'
                                    style={{ maxWidth: "15%", paddingTop: "2rem", paddingBottom: '2.5vh' }}
                                    src="./assets/media/masa_partners.jpg"
                                 />
                              </a>
                           </div>
                           {/* <div
                    className="col-md-2"
                    style={{ paddingTop: "2vh", position: "relative" }}
                  >
                    <div
                      style={{
                        position: "absolute",
                        bottom: "5%",
                        left: "15%",
                        fontFamily: "Roboto Condensed , sans-serif !important",
                      }}
                    >
                      <span style={{ fontSize: "1.25rem" }}>
                        Venture Sponsor
                      </span>

                      <a href="https://www.energyfoundry.com/">
                        <img alt='sponsor'
                          style={{ maxWidth: "80%", paddingTop: "2rem" }}
                          src="./assets/media/masa_partners.jpg"
                        />
                      </a>
                    </div>
                  </div> */}
                           <div
                              style={{
                                 display: "flex",
                                 flex: "1",
                                 margin: 'auto',
                                 alignItems: "center",
                                 flexDirection: "row",
                                 justifyContent: 'space-around',
                                 paddingLeft: "2.5vw",
                              }}
                           >
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed , sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "45%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/max_duckworth.jpeg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Max Duckworth,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Co-Founder</i>{" "}
                                    <a href="https://www.linkedin.com/in/max-duckworth-9b89bb52/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                              <div
                                 style={{
                                    textAlign: "center",
                                    fontFamily: "Roboto Condensed, sans-serif !important",
                                 }}
                              >
                                 <img alt='sponsor'
                                    style={{
                                       borderRadius: "100%",
                                       width: "50%",
                                       height: "85%",
                                       boxShadow: "0px 0px 25px 10px #B1B1B1",
                                    }}
                                    src="./assets/media/sarah_godlewski.jpeg"
                                 />
                                 <div style={{ fontSize: "1.1rem" }}>
                                    Sarah Godlewski,{" "}
                                    <i style={{ fontSize: ".85rem" }}>Co-Founder</i>{" "}
                                    <a href="https://www.linkedin.com/in/sarahgodlewski/">
                                       <LinkedInIcon />
                                    </a>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <div
                           className="row"
                           style={{ height: "50%", justifyContent: "center" }}
                        >
                           <div
                              style={{
                                 textAlign: "center",
                                 width: "80%",
                                 marginTop: "2vh",
                                 fontSize: "1.15rem",
                                 fontFamily: "Roboto Condensed, sans-serif",
                              }}
                           >
                              Sarah and Max met in 2013 through their volunteer board work
                              for UNICEF USA. Sarah had just left her corporate career to
                              become a public servant, while Max was taking a break after
                              twenty years in the energy & environmental arena. At the
                              time, social impact investment had been approached through a
                              philanthropic lens or with the expectation of modest, if
                              any, financial returns. A couple of years later, Max and
                              Sarah co-founded MaSa Partners to build a financially
                              sustainable venture that invests, grows and recycles
                              capital. Since inception, MaSa Partners has built a
                              multi-sector portfolio addressing some of our greatest
                              challenges, such as climate change and gender & income
                              inequality.
                           </div>
                        </div>
                     </div>
                  </section>
               </div>
            </div>
            {/* <div style={{display:"block", width:"100% !important", justifyContent: "center !important", textAlign: "center", marginTop:"5vh", borderRadius:"10%", marginBottom:"7.5vh",}}>
          <h1 style={{textAlign:"center",fontWeight:"900",color:"white",fontFamily: "Roboto Condensed, sans-serif", paddingTop:"5vh", paddingBottom:"5vh"}}>
            THANK YOU TO OUR INDUSTRY PARTNERS
          </h1>
          <img alt='sponsor'
            src="./assets/events/vsvc21/sponsors/image-1.webp"
            style={{width:"70%"}}
            alt="industry-partners"
          />
        </div>*/}
         </div>

         <section
            className="container mobile-sponsor-view"
            style={{
               backgroundColor: "white",
               borderRadius: "10px",
               width: "100%",
            }}
         >
            <SponsorsSection />
         </section>
      </>
   );
};
